// Pages whose edits save in the background (the Pipeline) register a flush
// function here, so "Update now" can finish those saves before it reloads the
// tab. A flush resolves true when everything it holds reached the server.
const flushers = new Set();

/** Register a flush function; returns the unregister function (for cleanup). */
export function registerPendingSaves(flush) {
  flushers.add(flush);
  return () => {
    flushers.delete(flush);
  };
}

/** Run every registered flush. Resolves true only if all of them succeeded. */
export async function flushPendingSaves() {
  const results = await Promise.all(
    Array.from(flushers).map(flush =>
      Promise.resolve()
        .then(flush)
        .catch(() => false)
    )
  );
  return results.every(result => result !== false);
}
